export const COUNTRIES = [
  ["IN", "India", "INR"], ["US", "United States", "USD"], ["GB", "United Kingdom", "GBP"], ["CA", "Canada", "CAD"],
  ["AU", "Australia", "AUD"], ["NZ", "New Zealand", "NZD"], ["IE", "Ireland", "EUR"], ["DE", "Germany", "EUR"],
  ["FR", "France", "EUR"], ["ES", "Spain", "EUR"], ["IT", "Italy", "EUR"], ["NL", "Netherlands", "EUR"],
  ["BE", "Belgium", "EUR"], ["AT", "Austria", "EUR"], ["PT", "Portugal", "EUR"], ["FI", "Finland", "EUR"],
  ["GR", "Greece", "EUR"], ["LU", "Luxembourg", "EUR"], ["SE", "Sweden", "SEK"], ["NO", "Norway", "NOK"],
  ["DK", "Denmark", "DKK"], ["CH", "Switzerland", "CHF"], ["PL", "Poland", "PLN"], ["AE", "United Arab Emirates", "AED"],
  ["SA", "Saudi Arabia", "SAR"], ["QA", "Qatar", "QAR"], ["SG", "Singapore", "SGD"], ["MY", "Malaysia", "MYR"],
  ["JP", "Japan", "JPY"], ["KR", "South Korea", "KRW"], ["HK", "Hong Kong", "HKD"], ["ID", "Indonesia", "IDR"],
  ["PH", "Philippines", "PHP"], ["TH", "Thailand", "THB"], ["VN", "Vietnam", "VND"], ["BD", "Bangladesh", "BDT"],
  ["LK", "Sri Lanka", "LKR"], ["NP", "Nepal", "NPR"], ["ZA", "South Africa", "ZAR"], ["NG", "Nigeria", "NGN"],
  ["KE", "Kenya", "KES"], ["EG", "Egypt", "EGP"], ["BR", "Brazil", "BRL"], ["MX", "Mexico", "MXN"],
];

export const CURRENCIES = [...new Set(COUNTRIES.map((c) => c[2]))].sort();

export const countryName = (cc) => COUNTRIES.find((c) => c[0] === cc)?.[1] || cc || "—";
export const currencyFor = (cc) => COUNTRIES.find((c) => c[0] === cc)?.[2] || "USD";

export function detectCountry() {
  const saved = localStorage.getItem("ww_country");
  if (saved) return saved;
  const region = (navigator.language || "").split("-")[1]?.toUpperCase();
  if (region && COUNTRIES.some((c) => c[0] === region)) return region;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  if (tz === "Asia/Kolkata" || tz === "Asia/Calcutta") return "IN";
  if (tz.startsWith("America/")) return "US";
  if (tz === "Europe/London") return "GB";
  if (tz.startsWith("Australia/")) return "AU";
  return "IN";
}

export const browserTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const TIMEZONES = (() => {
  try {
    const list = Intl.supportedValuesOf("timeZone");
    return list.includes("UTC") ? list : ["UTC", ...list];
  } catch {
    return ["UTC", "Asia/Kolkata", "America/New_York", "America/Los_Angeles", "Europe/London", "Europe/Berlin", "Europe/Paris", "Australia/Sydney"];
  }
})();
